/* eslint-disable */
import { IDetailsAction, IDetailsState } from './types';

export const DEVICE_INFO = 'DEVICE_INFO';
export const ACTIVE = 'ACTIVE';
export const ZONES = 'ZONES';
export const UPDATE_ZONE_SETPOINT = 'UPDATE_ZONE_SETPOINT';
export const CONTROL_PERIPHERALS = 'CONTROL_PERIPHERALS';

export function BeeDetailsReducer(state: IDetailsState, action: IDetailsAction) {
  switch (action.type) {
    case DEVICE_INFO:
      const searchBeeData = action.payload;
      return {
        ...state,
        deviceInfo: {
          ...state.deviceInfo,
          ...searchBeeData.bee,
          ...searchBeeData,
          udprn: searchBeeData?.physicalAddress?.udprn,
        },
      };
    case ACTIVE:
      const active = action.payload;
      return {
        ...state,
        active,
      };
    case ZONES:
      const zones = action.payload;
      return {
        ...state,
        zones,
      };
    case UPDATE_ZONE_SETPOINT:
      const { zoneId, setpoint } = action.payload;
      const zonesData = [...state.zones];
      const index = zonesData.findIndex(({ zone_id }) => zone_id === zoneId);
      zonesData[index] = { ...zonesData[index], setpoint };
      return {
        ...state,
        zones: [...zonesData],
      };
    case CONTROL_PERIPHERALS:
      const controlPeripherals = action.payload;
      return {
        ...state,
        controlPeripherals,
      };
    default:
      return { ...state };
  }
}
